import { DUMP_TYPES } from '../actions/dumpActions';

// Helper functions to handle localStorage
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('dumpState', JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save state to localStorage:', error);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('dumpState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (error) {
    console.error('Failed to load state from localStorage:', error);
    return undefined;
  }
};

const initialState = loadFromLocalStorage() || {};

const dumpReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case DUMP_TYPES.PROJECT_CREATION:
      newState = {
        ...state,
        projectForm: {
          ...action.payload,
        },
      };
      break;

    case DUMP_TYPES.PART_CREATION:
      newState = {
        ...state,
        partForm: {
          ...action.payload,
        },
      };
      break;

    case DUMP_TYPES.CLEAR:
      newState = {
        ...state,
      };
      if (action.payload && newState.hasOwnProperty(action.payload)) {
        delete newState[action.payload];
      }
      break;

    default:
      newState = state;
  }

  saveToLocalStorage(newState);

  return newState;
};

export default dumpReducer;
